import Joi from '@hapi/joi'

export const tagSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid("0").required().label("Estate").messages({
        "any.invalid": `Operation Entity cannot have invalid characters`,
        "any.required": `Operation Entity required`
    }),
    tag: Joi.string().required().label("Tag").messages({
        "string.empty": `Tag Name required`
    })
}